module.exports = __webpack_public_path__ + "r-v3/img/q-pin_off.0d5f178b.svg";